import { render } from "./_base-input-checkbox.vue?vue&type=template&id=3a63eff8"
import script from "./_base-input-checkbox.vue?vue&type=script&lang=js"
export * from "./_base-input-checkbox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./_base-input-checkbox.vue?vue&type=style&index=0&id=3a63eff8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__